/** Mark-read request accepted by the recipient-facing conversation action API. */
export interface MarkConversationActionRequest {
  conversationId: string;
  fan_id: string;
  creator_id: string;
  email_attribution_context?: string;
}

/** Mark-read request accepted by the creator-facing conversation action API. */
export interface MarkCreatorConversationActionRequest {
  conversation_id: string;
  creator_id: string;
  email_attribution_context?: string;
}

/** Builds the authoritative fan conversation-open request, including verified context when present. */
export function buildMarkConversationApiRequest({
  conversationId,
  fan_id,
  creator_id,
  email_attribution_context,
}: MarkConversationActionRequest) {
  return {
    url: `/public/v1/forum/mark_conversation/${conversationId}`,
    method: 'PUT' as const,
    params: { fan_id, creator_id, email_attribution_context },
  };
}

/** Builds the authoritative creator conversation-open request, including verified context when present. */
export function buildMarkCreatorConversationApiRequest({
  conversation_id,
  creator_id,
  email_attribution_context,
}: MarkCreatorConversationActionRequest) {
  return {
    url: 'public/v1/forum/mark_creator_conversation',
    method: 'PUT' as const,
    body: { conversation_id, creator_id, email_attribution_context },
  };
}
